import { async_versionCheck } from "app/application/api";
import { notifier } from "common/notifier";
//-- Constants -------------------------------------------------------------------------------------------------------------------------------
export const LOADING = "FULL_PAGE_LOADING";
export const AUTHENTICATION = "PAGE_AUTHENTICATION";
export const AUTHORISATION = "PAGE_AUTHORISATION";
export const ERROR = "PAGE_ERROR";
export const MAINTENANCE = "PAGE_MAINTENANCE";
export const SHOW = "PAGE_SHOW";
export function createAction_PageLoading(isLoading) {
    return {
        type: LOADING,
        isLoading: isLoading
    };
}
export function createAction_PageAuthentication(isAuthenticated) {
    return {
        type: AUTHENTICATION,
        isAuthenticated: isAuthenticated
    };
}
export function createAction_PageAuthorisation(isAuthorised) {
    return {
        type: AUTHORISATION,
        isAuthorised: isAuthorised
    };
}
export function createAction_PageError(isInError) {
    return {
        type: ERROR,
        isInError: isInError
    };
}
export function createAction_PageUnderMaintenance(isUnderMaintenance, underMaintenanceMessage) {
    return {
        type: MAINTENANCE,
        isUnderMaintenance: isUnderMaintenance,
        underMaintenanceMessage: underMaintenanceMessage
    };
}
export function createAction_ShowPage() {
    return {
        type: SHOW
    };
}
//-------------------------------------------------------------------------------------------------------------------------------
//-- Page not authorised -------------------------------------------------------------------------------------------------------------------------------
export function createAction_VersionCheck() {
    return (dispatch) => {
        async_versionCheck(dispatch)
            .then(() => { }, () => {
            notifier.notifyNewVersionWarning("More Insights for you", "We've got a new version of Insights out! Just refresh to get the latest features.");
        });
    };
}
